import { render, staticRenderFns } from "./ExamMain.vue?vue&type=template&id=77da96df"
import script from "./ExamMain.vue?vue&type=script&lang=js"
export * from "./ExamMain.vue?vue&type=script&lang=js"
import style0 from "./ExamMain.vue?vue&type=style&index=0&id=77da96df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports